module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/fontawesome-webfont.ttf
// module id = ./node_modules/@ps/common-core/dist/fonts/fontawesome-webfont.ttf
// module chunks = 1